import React from 'react';
import SPAPageHeader from '@/components/admin/SysadminSPA/shared/SPAPageHeader';
import PromptDetail from './PromptDetail';
import PromptList from './PromptList';
import useLangfusePrompts from './useLangfusePrompts';

// AIDEV-NOTE: Mounted only inside the sysadmin SPA (/langfuse/prompts). The list drills the rail
// and the selected prompt owns the page header, so the route frame must not add one.
const Index = () => {
  const {
    error,
    isLoadingList,
    isLoadingPrompt,
    isSaving,
    isTesting,
    loadPrompt,
    prompts,
    savePromptVersion,
    selectedPrompt,
    testPrompt,
    testResult,
  } = useLangfusePrompts();

  const handleVersionChange = (version: number) => {
    if (!selectedPrompt) return;
    loadPrompt(selectedPrompt.name, version);
  };

  const handleTest = (variables: Record<string, string>) => {
    if (!selectedPrompt) return;
    testPrompt(selectedPrompt.name, variables, selectedPrompt.version);
  };

  return (
    <>
      <PromptList
        isLoading={isLoadingList}
        prompts={prompts}
        selectedName={selectedPrompt?.name ?? null}
        onSelect={name => loadPrompt(name)}
      />

      {selectedPrompt ? (
        <PromptDetail
          isLoading={isLoadingPrompt}
          isSaving={isSaving}
          isTesting={isTesting}
          prompt={selectedPrompt}
          testResult={testResult}
          onSave={savePromptVersion}
          onTest={handleTest}
          onVersionChange={handleVersionChange}
        />
      ) : (
        <>
          <SPAPageHeader title="Prompt Management" />
          <p className="tw-m-0 tw-text-sm tw-text-spa-secondary">
            {isLoadingList || isLoadingPrompt ? 'Loading…' : 'Pick a prompt on the left to view, edit, and test it.'}
          </p>
        </>
      )}

      {error && <p className="tw-mb-0 tw-mt-4 tw-text-sm tw-text-spa-error">{error}</p>}
    </>
  );
};

export default Index;
